module.exports = __webpack_public_path__ + "img/sidebar-toggle-off.af0c8272.svg";